/* eslint-disable no-unused-vars */
//[Aqeel]: Needed for reset password functionality.
export const DOMAIN_ID = 'Hub-ResetPassword';
export const NO_ACC_DOMAIN_ID = 'Hub-NoAccount-ResetPassword';
export const ORG_IMAGE_TYPE_ID = 1;
export const LOGO_IMAGE_TYPE_ID = 3;
export const DELETED_ORG_STATUS = 2;
export const ORG_CUSTOMFIELD = 1;
export const SUCCESS_STATUS = 200;
export const UNAUTHORIZED = 401;
export const FORBIDDEN_STATUS = 403;
export const SYSTEM_UNAVAILABLE_STATUS = 404;
export const MAX_BREAD_CRUMBS = 10;
export const ParamIdString = 'id';
export const SYSTEM_UNAVAILABLE_RESPONSE_DATA_START =
  /<!DOCTYPE html>[\s\S]*<title>Web App - Unavailable<\/title>/;
export const TEST_LANDING_PAGE_ID = 1;
export const OROMIA_LANDING_PAGE_ID = 2;
export const MEMBER_READ_PERMISSION = 11;
export const MEMBER_EDIT_PERMISSION = 23;
export const ORGANIZATION_CURRENT_READ_PERMISSION = 40;
export const ORGANIZATION_WRITE_PERMISSION = 16;
export const ORGANIZATION_IMMEDIATE_READ_PERMISSION = 42;
export const ORGANIZATION_TREE_READ_PERMISSION = 43;
export const CREATE_TOKENS_PERMISSION = 22;
export const YIELD_READ_PERMISSION = 59;
export const YIELD_WRITE_PERMISSION = 60;
export const DOWNLOAD_MEMBERS_CSV_PERMISSION = 1123;
export const CERTIFICATE_READ_PERMISSION = 1124;
export const CERTIFICATE_WRITE_PERMISSION = 1125;
export const MEMBER_PARENT_FIELD_TYPE_NUMBER = 9;
export const MEMBER_FIELD_NAME_NOTES = 'Notes';
export const CHAT_PERMISSION = 61;
export const LICENSE_READ_PERMISSION = 1135;
export const LICENSE_WRITE_PERMISSION = 1136;
export const CUSTOM_FIELD_READ_PERMISSION = 69;
export const CUSTOM_FIELD_WRITE_PERMISSION = 70;
export const ASSET_TYPES_WRITE_PERMISSION = 28;
export const ASSET_TYPES_READ_PERMISSION = 71;
export const ASSET_TYPES_LIST_WRITE_PERMISSION = 14;
export const ASSET_TYPES_LIST_READ_PERMISSION = 14; // TODO: Adjust the permission ID later when it becomes available.
export const ENUM_READ_PERMISSION = 72; // TODO: Adjust the permission ID later when it becomes available.
export const ENUM_WRITE_PERMISSION = 72;
export const COUNTRIES_READ_PERMISSION = 73; // TODO: Adjust the permission ID later when it becomes available.
export const COUNTRIES_WRITE_PERMISSION = 73;
export const UNIT_READ_PERMISSION = 75; // TODO: Adjust the permission ID later when it becomes available.
export const UNIT_WRITE_PERMISSION = 75;
export const ADMIN_LOCALE_READ_PERMISSION = 76; // TODO: Adjust the permission ID later when it becomes available.
export const ADMIN_LOCALE_WRITE_PERMISSION = 76;
export const CONSENT_READ_PERMISSION = 50; // TODO: Adjust the permission ID later when it becomes available.
export const CONSENT_WRITE_PERMISSION = 50;
export const CONTRACT_TYPES_READ_PERMISSION = 77; // TODO: Adjust the permission ID later when it becomes available.
export const CONTRACT_TYPES_WRITE_PERMISSION = 77;
export const TRAINING_TOPICS_READ_PERMISSION = 79; // TODO: Adjust the permission ID later when it becomes available.
export const TRAINING_TOPICS_WRITE_PERMISSION = 79;
export const FUNCTIONS_READ_PERMISSION = 80;
export const FUNCTIONS_WRITE_PERMISSION = 80; // TODO: Adjust the permission ID later when it becomes available.
export const KNOWN_PERSONS_READ_PERMISSION = 81; // TODO: Adjust the permission ID later when it becomes available.
export const KNOWN_PERSONS_WRITE_PERMISSION = 81;
export const TRAINING_READ_PERMISSION = 78; // TODO: Adjust the permission ID later when it becomes available.
export const TRAINING_WRITE_PERMISSION = 78;
export const CERTIFICATE_TYPE_WRITE_PERMISSION = 74;
export const CERTIFICATE_TYPE_READ_PERMISSION = 74; // TODO: Adjust the permission ID later when it becomes available.
export const BULK_UPLOAD_REQUEST_READ_PERMISSION = 82;
export const BULK_PURCHASE_READ_PERMISSION = 82; // TODO: Adjust the permission ID later when it becomes available.
export const LIST_MANAGEMENT_READ_PERMISSION = 1137;
export const LIST_MANAGEMENT_EDIT_PERMISSION = 1138;
export const BANK_READ_PERMISSION = 1113;
export const BANK_WRITE_PERMISSION = 1114;
export const BANK_TRANSACTION_PERMISSION = 1115;
export const BATCH_READ_PERMISSION = 86;
export const BATCH_WRITE_PERMISSION = 87;
export const BATCH_BUY_SELL_PERMISSION = 88;
export const LOCALIZATION_PERMISSION = 36;
export const USER_UNBIND_SOFT_PERMISSION = 37;
export const USER_UNBIND_HARD_PERMISSION = 38;
export const LOGS_USER_PERMISSION = 83;
export const LOGS_GENERAL_PERMISSION = 84;
export const SERVER_RENDERING_THRESHOLD = 2500;
export const CONTRACT_TYPE_ID = 70;
export const CONTRACT_MAX_FILE_SIZE = 5242880;
export const CONTRACT_DESCRIPTION_MAX_LENGTH = 300;
export const ACCOUNT_TYPE_ID = 6;
export const ORG_TYPE_ID = 1;
export const PROFILE_IMAGE_MAX_SIZE = 1048576;
export const PROFILE_IMAGE_MIN_WIDTH = 380;
export const PROFILE_IMAGE_MIN_HEIGHT = 380;
export const STANDARD_TEXT_MAX_LENGTH = 50;
export const ORG_DESCRIPTION_MAX_LENGTH = 1200;
export const ORG_NOTES_MAX_LENGTH = 1200;
export const POST_CODE_MAX_LENGTH = 20;
export const ADDRESS_MAX_LENGTH = 200;
export const TARGET = 'hub';
export const SIGN_UP_FLAG = 'SelfSignup';

export const URGENCY = [
  {
    id: 1,
    name: 'General inquiry',
  },
  {
    id: 2,
    name: 'Important, needs attention',
  },
  {
    id: 3,
    name: 'Urgent, blocking critical task',
  },
];

export enum MOOD_TYPE {
  VerySatisfied = 'Very Satisfied',
  Satisfied = 'Satisfied',
  Dissatisfied = 'Dissatisfied',
  VeryDissatisfied = 'Very Dissatisfied',
}

export const TEMPLATE_TYPE = {
  Member: 0,
  Staff: 1,
  Organisation: 2,
};

export const ASSET_BASETYPE = {
  Asset: 2,
};

export const TEMPLATE_GENDER = {
  Male: 'M',
  Female: 'F',
  NonBinary: 'N',
  Other: 'O',
};

export const TEMPLATE_STATUS = {
  Active: {
    id: 0,
    name: 'Active',
    termId: 'ACTIVE',
  },
  Not_Active: {
    id: 1,
    name: 'Not Active',
    termId: 'NOT_ACTIVE',
  },
  Deleted: {
    id: 3,
    name: 'Deleted',
    termId: 'DELETED',
  },
};

export const GENDER = [
  {
    id: 'M',
    name: 'Male',
    termId: 'MALE',
  },
  {
    id: 'F',
    name: 'Female',
    termId: 'FEMALE',
  },
  {
    id: 'N',
    name: 'Non-Binary',
    termId: 'NONBINARY',
  },
  {
    id: 'O',
    name: 'Other/Unspecified',
    termId: 'NOGENDER',
  },
];

export type PATHS =
  | 'ROOT'
  | 'LOGIN'
  | 'HELP'
  | 'SIGN_UP'
  | 'RESET_PW'
  | 'FORGOT_PW'
  | 'ACCESS_TOKEN'
  | 'ACCOUNT_BLOCK'
  | 'SYSTEM_UNAVAILABLE'
  | 'NO_LICENSE'
  | 'USER_SELECT'
  | 'ORGANISATIONS'
  | 'ORGANISATION'
  | 'MY_ORGANISATION'
  | 'CHILD_ORGANISATIONS'
  | 'USERS'
  | 'NEW_USER_ORG'
  | 'CUSTOM_FIELDS'
  | 'ADD_CUSTOM_FIELDS'
  | 'ADMINISTRATION'
  | 'START_BULK_IMPORT'
  | 'PROFILE'
  | 'SEARCH'
  | 'STAFF'
  | 'CERTIFICATES'
  | 'CERTIFICATE'
  | 'ADD_CERTIFICATE'
  | 'USER_GUIDANCE'
  | 'ASSET_TYPES'
  | 'ASSET_TYPE_LIST'
  | 'ADD_ASSET_TYPE_LIST'
  | 'LOCALISATION'
  | 'LIST_MANAGEMENT'
  | 'ENUMS'
  | 'ADD_ENUM'
  | 'LICENSES'
  | 'ADD_LICENSE'
  | 'COUNTRIES'
  | 'SURVEYS'
  | 'MEMBERS'
  | 'BULK_UPLOAD_TEMPLATES'
  | 'BULK_UPLOAD'
  | 'MEMBER'
  | 'ADD_MEMBER'
  | 'ADD_STAFF'
  | 'ADD_ORGANISATION'
  | 'REPORTS'
  | 'UNITS'
  | 'ADD_UNIT'
  | 'CULTURES'
  | 'CONSENTS'
  | 'ADD_CONSENT'
  | 'CONTRACT_TYPES'
  | 'ADD_CONTRACT_TYPE'
  | 'TRAINING_TOPICS'
  | 'ADD_TRAINING_TOPIC'
  | 'FUNCTIONS'
  | 'TRAININGS'
  | 'ADD_TRAINING'
  | 'TRAINING'
  | 'BULK_UPLOAD_REQUEST'
  | 'CERTIFICATE_TYPES'
  | 'ADD_CERTIFICATE_TYPE'
  | 'LOGS'
  | 'ON_HAND'
  | 'HISTORY'
  | 'PROCESSING'
  | 'E404'
  | 'UPLOAD_SECTION'
  | 'TRANSACTIONS'
  | 'BULK_PURCHASE'
  | 'TRANSACTION_REPORT'
  | 'PAYMENT_MANAGER'
  | 'BATCH'
  | 'ADD_BATCH'
  | 'ACCOUNT';

export const ROOT_PATHS: Record<PATHS, string> = {
  ROOT: '/',
  HELP: '/help',
  LOGIN: '/login',
  SIGN_UP: '/signup',
  RESET_PW: '/resetpassword',
  FORGOT_PW: '/forgotpassword',
  ACCESS_TOKEN: '#access_token',
  SYSTEM_UNAVAILABLE: '/systemunavailable',
  NO_LICENSE: '/nolicense',
  ACCOUNT_BLOCK: '/accountblock',
  USER_SELECT: '/userselection',
  CHILD_ORGANISATIONS: '/childOrg',
  USERS: '/users',
  NEW_USER_ORG: '/new-user-org',
  CUSTOM_FIELDS: '/custom_fields',
  ADD_CUSTOM_FIELDS: '/add_custom_fields',
  ADMINISTRATION: '/administration',
  START_BULK_IMPORT: '/start-BI',

  PROFILE: '/profile',
  SEARCH: '/search',

  STAFF: '/staff',
  ADD_STAFF: '/add_staff',

  ORGANISATIONS: '/organisations',
  ORGANISATION: '/organisation',
  MY_ORGANISATION: '/my_organization',
  ADD_ORGANISATION: '/add_organisation',

  CERTIFICATES: '/certificates',
  CERTIFICATE: '/certificate',
  ADD_CERTIFICATE: '/add_certificate',
  USER_GUIDANCE: '/userGuidance',
  ASSET_TYPES: '/asset_types',
  ASSET_TYPE_LIST: '/asset_type_list',
  ADD_ASSET_TYPE_LIST: '/add_asset_type_list',
  LOCALISATION: '/localisation',

  LIST_MANAGEMENT: '/list-management',

  LICENSES: '/licenses',
  ADD_LICENSE: '/add_licenses',

  ENUMS: '/enums',
  ADD_ENUM: '/add_enum',

  COUNTRIES: '/countries',

  UNITS: '/units',
  ADD_UNIT: '/add_unit',

  CULTURES: '/cultures',

  CONSENTS: '/consents',
  ADD_CONSENT: '/add_consent',

  CONTRACT_TYPES: '/contract_types',
  ADD_CONTRACT_TYPE: '/add_contract_type',

  SURVEYS: '/surveys',
  MEMBERS: '/members',
  BULK_UPLOAD_TEMPLATES: '/bulk-upload-templates',
  BULK_UPLOAD: '/bulk-upload',
  MEMBER: '/member',
  ADD_MEMBER: '/add_member',
  REPORTS: '/reports',
  ACCOUNT: '/account',

  TRAINING_TOPICS: '/training_topics',
  ADD_TRAINING_TOPIC: '/add_training_topic',

  FUNCTIONS: '/functions',

  TRAININGS: '/trainings',
  ADD_TRAINING: '/add_training',
  TRAINING: '/training',

  BULK_UPLOAD_REQUEST: '/bulk-upload-request',

  CERTIFICATE_TYPES: '/certificate_types',
  ADD_CERTIFICATE_TYPE: '/add_certificate_type',

  LOGS: '/logs',

  ON_HAND: '/on_hand',
  HISTORY: '/history',
  PROCESSING: '/processing',
  UPLOAD_SECTION: '/upload-section',
  TRANSACTIONS: '/transactions',
  BULK_PURCHASE: '/bulk-purchase',
  TRANSACTION_REPORT: '/transaction-report',
  PAYMENT_MANAGER: '/payment-manager',
  BATCH: '/batch',
  ADD_BATCH: '/add_batch',

  E404: '/404',
};

export const ItemTypeId = {
  Organisation: 1,
  User: 6,
};

export const MANDATORY_LEVEL = {
  Optional: 0,
  Conditional: 1,
  Mandatory: 2,
};

export const CustomFieldColumnType = {
  None: 0,
  String: 1,
  Date: 2,
  Integer: 3,
  Decimal: 4,
  Enum: 5,
  Image: 6,
  MultiEnum: 7,
  UserId: 8,
  Header: 9,
  DateTime: 10,
  Id: 11,
  MultiLineString: 12,
};

export const CustomFieldItemType = {
  Organization: 1,
  Identity: 6,
  User: 53,
  Certificate: 55,
  Field: 20,
};

export const featureFlags = {
  YIELD: 'Yield',
  STAFFORGS: 'StaffOrgs',
  VIEWSTAFF: 'ViewStaff',
  FILTER_SELECTOR: 'FilterSelector',
  CERTIFICATE: 'Certificate',
  ACTIVE_STATUS_CHANGE: 'ActiveStatusChange',
  INVENTORY_MANAGEMENT: 'InventoryManagement',
  PAYMENTS_MANAGEMENT: 'PaymentsManagement',
};

export const Label_Code = 'CODE';
export const OrgPrefixUppercase = '#C';
export const FilterSelector = {
  filter: 'filter',
  condition: 'condition',
  truncation: 'truncation',
  IsEmpty: 'Is empty',
  IsNotEmpty: 'Is not empty',
  Is: 'Is',
  IsWithIcon: '= Is',
  EqualToWithIcon: '= Equal to',
  IsNot: 'Is not',
  NotEqualToWithIcon: '≠ Not equal to',
  Contains: 'Contains',
  DoesNotContain: 'Does not contain',
  StartsWith: 'Starts with',
  EndsWith: 'Ends with',
  GreaterThanWithIcon: '> Greater than',
  GreaterThanWithIconEntityName: '&gt; Greater than',
  LessThanWithIcon: '< Less than',
  LessThanWithIconEntityName: '&lt; Less than',
  GreaterThanOrEqualWithIcon: '≥ Greater than or equal to',
  LessThanOrEqualToWithIcon: '≤ Less than or equal to',
  IsOnOrAfterWithIcon: '≥ Is on or after',
  IsOnOrBeforeWithIcon: '≤ Is on or before',
};
export const CertificateField = {
  PremiumAmount: 'Premium Amount',
  PremiumAmountCurrency: 'Premium Amount Currency',
};

export const COLUMN_FILTER_ID = {
  Gender: 115,
  ActiveStatusProfile: 112,
  GPSCoordinates: 131,
  Roles: 134,
  AccountId: 110,
  MemberId: 109,
};

export const HELP_LINK = 'https://doc.agunity.com/hub';

export const SUPPORT_LEVEL = [
  { id: 0, name: '0' },
  { id: 1, name: '1' },
  { id: 2, name: '2' },
];

// 1=Farm, 2=Coop, 3=Admin, 4=Union, 5=RegionalCoop, any other value=General
export enum FUNCTION_TYPE {
  FARM = 1,
  COOP = 2,
  ADMIN = 3,
  UNION = 4,
  REGIONAL_COOP = 5,
}
